<template>
	<div>
		<el-dialog title="预览抽号任务" width="1200px" :visible.sync="previewDialogTableVisible" append-to-body :close-on-click-modal="false">
			<div class="previewbox">
				<el-table :data="gridData" border>
					<el-table-column property="nation" label="国际" align="center"></el-table-column>
					<el-table-column property="provinces" label="省、直辖市" align="center"></el-table-column>
					<el-table-column property="city" label="城市" align="center"></el-table-column>
					<el-table-column property="area" label="区域" align="center"></el-table-column>
					<el-table-column property="part" label="地区名称" align="center"></el-table-column>
					<el-table-column property="phone" label="号码" align="center"></el-table-column>
					<el-table-column property="createTime" label="创建时间" align="center"></el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pagination.pageNo"
						:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			gridData: [],
			previewDialogTableVisible: false,
			formLabelWidth: '120px',
			id: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			}
		};
	},
	methods: {
		openVisible(id) {
			this.id = id;
			this.queryData();
			this.previewDialogTableVisible = true;
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.queryData();
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.queryData();
		},
		queryData(id) {
			let url = `${this.$config.service.queryPhoneTaskResultList}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				method: 'POST',
				data: {
					id: that.id,
					currentPage: that.pagination.pageNo,
					pageSize: that.pagination.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						that.gridData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.gridData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.previewbox {
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
